'use client';

import i18next from 'src/i18n/client';
export default function LocaleProvider({ locale, messages, children }) {
    i18next.addResourceBundle(locale, 'common', messages, true, true);

    return children;
}
